// extracted by mini-css-extract-plugin
export var numpadContainer = "_n1-1";
export var phoneButton = "_n1-0";